import {
  getObject,
} from "@surya-digital/leo-ts-types";
import { SurveyLocalizedText, SurveyLocalizedTextDTO } from "../assets/surveyLocalizedText";
import { RespondentQuestionDetails, RespondentQuestionDetailsDTO } from "./respondentQuestionDetails";
import { ChatQuestionState } from "./chatQuestionState";


export namespace ChatSurveyElement {
  export interface WelcomeDTO {
    case: string;
    welcomePageText: SurveyLocalizedTextDTO;
  }
  
  export class Welcome {
    readonly isChatSurveyElementWelcome: boolean = true;
  
    readonly welcomePageText: SurveyLocalizedText;
  
  
    constructor(
    welcomePageText: SurveyLocalizedText
    ) {
      this.welcomePageText = welcomePageText;
    }
  
    static fromDTO(dto: WelcomeDTO): Welcome {
      const welcomePageText = SurveyLocalizedText.fromDTO(getObject(dto, "welcomePageText", InvalidChatSurveyElementWelcomeWelcomePageTextError));
      return new Welcome(
        welcomePageText
      );
    }
  
    toDTO(): WelcomeDTO {
      const dto: WelcomeDTO = {
        case: "WELCOME",
          welcomePageText: this.welcomePageText.toDTO()
      };
      return dto;
    }
    }
  
  Welcome.prototype.toString = function toString(): string {
    return `ChatSurveyElement.WELCOME(welcomePageText='${this.welcomePageText}')`;
  };
  
  export interface QuestionDTO {
    case: string;
    respondentQuestionDetails: RespondentQuestionDetailsDTO;
    questionState: ChatQuestionState.ChatQuestionStateDTO;
  }
  
  export class Question {
    readonly isChatSurveyElementQuestion: boolean = true;
  
    readonly respondentQuestionDetails: RespondentQuestionDetails;
    readonly questionState: ChatQuestionState.ChatQuestionState;
  
  
    constructor(
    respondentQuestionDetails: RespondentQuestionDetails, 
    questionState: ChatQuestionState.ChatQuestionState
    ) {
      this.respondentQuestionDetails = respondentQuestionDetails;
      this.questionState = questionState;
    }
  
    static fromDTO(dto: QuestionDTO): Question {
      const respondentQuestionDetails = RespondentQuestionDetails.fromDTO(getObject(dto, "respondentQuestionDetails", InvalidChatSurveyElementQuestionRespondentQuestionDetailsError));
      const questionState = ChatQuestionState.fromDTO(getObject(dto, "questionState", InvalidChatSurveyElementQuestionQuestionStateError));
      return new Question(
        respondentQuestionDetails,
        questionState
      );
    }
  
    toDTO(): QuestionDTO {
      const dto: QuestionDTO = {
        case: "QUESTION",
          respondentQuestionDetails: this.respondentQuestionDetails.toDTO(),
          questionState: this.questionState.toDTO()
      };
      return dto;
    }
    }
  
  Question.prototype.toString = function toString(): string {
    return `ChatSurveyElement.QUESTION(respondentQuestionDetails='${this.respondentQuestionDetails}',questionState='${this.questionState}')`;
  };
  
  export interface ThankYouDTO {
    case: string;
    thankYouPageText: SurveyLocalizedTextDTO;
  }
  
  export class ThankYou {
    readonly isChatSurveyElementThankYou: boolean = true;
  
    readonly thankYouPageText: SurveyLocalizedText;
  
  
    constructor(
    thankYouPageText: SurveyLocalizedText
    ) {
      this.thankYouPageText = thankYouPageText;
    }
  
    static fromDTO(dto: ThankYouDTO): ThankYou {
      const thankYouPageText = SurveyLocalizedText.fromDTO(getObject(dto, "thankYouPageText", InvalidChatSurveyElementThankYouThankYouPageTextError));
      return new ThankYou(
        thankYouPageText
      );
    }
  
    toDTO(): ThankYouDTO {
      const dto: ThankYouDTO = {
        case: "THANK_YOU",
          thankYouPageText: this.thankYouPageText.toDTO()
      };
      return dto;
    }
    }
  
  ThankYou.prototype.toString = function toString(): string {
    return `ChatSurveyElement.THANK_YOU(thankYouPageText='${this.thankYouPageText}')`;
  };
  

  export type ChatSurveyElement = Welcome | Question | ThankYou;

  export type ChatSurveyElementDTO = WelcomeDTO | QuestionDTO | ThankYouDTO;

  export const fromDTO = (dto: ChatSurveyElementDTO): ChatSurveyElement => {
    switch (dto.case) {
      case "WELCOME":
          return Welcome.fromDTO(dto as WelcomeDTO);
      case "QUESTION":
          return Question.fromDTO(dto as QuestionDTO);
      case "THANK_YOU":
          return ThankYou.fromDTO(dto as ThankYouDTO);
      default:
        throw new InvalidChatSurveyElementError(
            `Case ${dto.case} is not valid case of ChatSurveyElement.`
        );
    }
  };
}

export class InvalidChatSurveyElementError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyElementError";
  }
}
export class InvalidChatSurveyElementWelcomeError extends InvalidChatSurveyElementError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyElementWelcomeError";
  }
}

export class InvalidChatSurveyElementWelcomeWelcomePageTextError extends InvalidChatSurveyElementWelcomeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyElementWelcomeWelcomePageTextError";
  }
}

export class InvalidChatSurveyElementQuestionError extends InvalidChatSurveyElementError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyElementQuestionError";
  }
}

export class InvalidChatSurveyElementQuestionRespondentQuestionDetailsError extends InvalidChatSurveyElementQuestionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyElementQuestionRespondentQuestionDetailsError";
  }
}

export class InvalidChatSurveyElementQuestionQuestionStateError extends InvalidChatSurveyElementQuestionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyElementQuestionQuestionStateError";
  }
}

export class InvalidChatSurveyElementThankYouError extends InvalidChatSurveyElementError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyElementThankYouError";
  }
}

export class InvalidChatSurveyElementThankYouThankYouPageTextError extends InvalidChatSurveyElementThankYouError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyElementThankYouThankYouPageTextError";
  }
}
